// Mailing Black-List

export const mailDomainsBlacklist = new RegExp(`^(?![a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(gmail\.com|yahoo\.com|ymail\.com|hotmail\.com|aol\.com|example\.com|secret\.com|icloud\.com|comcast\.net|msn\.com|rocketmail\.com|sbcglobal\.net|verizon\.net|outlook\.com|cox\.net|earthlink\.net|test\.com)$)`);

// Hubspot Forms Fields

// GENERAL FORM
// https://app.hubspot.com/forms/7284441/b0bc5e22-8edc-4222-aa58-1cf62ee80355/submissions
export const hubspot_generalForm_fields = [
	"firstname",
	"email",
	"how_did_you_hear_about_us_",
	"company_size",
	"referrer",
	"utm_content",
	"utm_medium",
	"utm_source",
	"hsmi",
	"hsa_ver",
	"hsa_cam",
	"utm_campaign",
	"hsa_grp",
	"hsa_acc",
	"hsa_ad",
	"hsa_net",
	"utm_term",
	"gclid",
	"hsa_tgt",
	"hsa_mt",
	"hsa_src",
	"hsa_kw",
	"msclkid",
	"gclid_field",
	"hsenc"
]

export const hubspot_contentDownloadForm_fields = [
	"firstname",
	"email",
	"how_did_you_hear_about_us_",
	"company_size",
	"referrer",
	"utm_content",
	"utm_medium",
	"utm_source",
	"hsmi",
	"hsa_ver",
	"hsa_cam",
	"utm_campaign",
	"hsa_grp",
	"hsa_acc",
	"hsa_ad",
	"hsa_net",
	"utm_term",
	"gclid",
	"hsa_tgt",
	"hsa_mt",
	"hsa_src",
	"hsa_kw",
	"msclkid",
	"gclid_field",
	"hsenc"
]


export const hubspot_contentDownloadShortForm_fields = [
	"email",
	"referrer",
	"hsa_ver",
	"hsa_cam",
	"hsa_grp",
	"hsa_acc",
	"hsa_ad",
	"hsa_net",
	"hsa_tgt",
	"hsa_mt",
	"hsa_src",
	"hsa_kw",
	"gclid",
	"utm_medium",
	"utm_campaign",
	"utm_term",
	"utm_source",
	"msclkid",
	"hsenc",
	"hsmi",
	"gclid_field",
	"utm_content",
	"inf_contact_key",
	"ssrid"
]

export const hubspot_generalShortForm_fields = [
	"email",
	"referrer",
	"hsa_ver",
	"hsa_cam",
	"hsa_grp",
	"hsa_acc",
	"hsa_ad",
	"hsa_net",
	"hsa_tgt",
	"hsa_mt",
	"hsa_src",
	"hsa_kw",
	"gclid",
	"utm_medium",
	"utm_campaign",
	"utm_term",
	"utm_source",
	"msclkid",
	"hsenc",
	"hsmi",
	"gclid_field",
	"utm_content",
	"inf_contact_key",
	"ssrid"
]

export const hubspot_contactUsForm_fields = [
	"email",
	"notes",
	"referrer",
	"utm_content",
	"utm_medium",
	"utm_source",
	"hsmi",
	"hsa_ver",
	"hsa_cam",
	"utm_campaign",
	"hsa_grp",
	"hsa_acc",
	"hsa_net",
	"utm_term",
	"gclid",
	"hsa_tgt",
	"hsa_mt",
	"hsa_src",
	"hsa_kw",
	"msclkid",
	"gclid_field",
	"hsenc"
]

export const hubspot_dataReportLeads_fields = [
	"email",
	"utm_campaign",
	"utm_medium",
	"utm_content",
	"utm_source",
	"utm_term",
	"referrer",
	"gclid_field"
]

export const hubspot_astroReportLeads_fields = [
	"email",
	"utm_campaign",
	"utm_medium",
	"utm_content",
	"utm_source",
	"utm_term",
	"hsa_acc",
	"hsa_cam",
	"hsa_grp",
	"hsa_ad",
	"hsa_net",
	"hsa_ver",
	"li_fat_id",
	"inf_contact_key",
	"referrer",
	"gclid_field"
]

export const hubspot_SubscribeForm_fields = [
	"email",
	"gclid_field",
	"referrer",
	"hsa_ver",
	"hsa_cam",
	"hsa_grp",
	"hsa_acc",
	"hsa_ad",
	"hsa_net",
	"hsa_tgt",
	"hsa_mt",
	"hsa_src",
	"hsa_kw",
	"gclid",
	"utm_medium",
	"utm_campaign",
	"utm_term",
	"utm_source",
	"hsenc",
	"hsmi",
	"msclkid",
	"utm_content",
	"inf_contact_key",
	"ssrid"
]

export const fieldsFilter = (currentFields, allowedFields) =>{
	 const filteredFieldsArray = []

	 currentFields.forEach(field => {
  	if (allowedFields.includes(field.name)) {
  		filteredFieldsArray.push({name: field.name, value: field.value})
  	}
  })

	return filteredFieldsArray
}